import React from 'react';
import { Button } from 'reactstrap';
import YouTube from 'react-youtube';
import { FadeLoader } from 'react-spinners';

import '../styles/YoutubeView.css';

class YoutubeView extends React.Component {
	state = {
		loading: true,
		display: 'none'
	}

	opts = {
		height: '100%',
		width: '100%',
		playerVars: { // https://developers.google.com/youtube/player_parameters
			autoplay: 1
		}
	};

	componentWillMount() {}

	_onReady(event) {

		setTimeout(() => {
			event.target.playVideo();
		}, 1000 );
	}

	_close(){
		this.props.toggle();
		this.setState({ loading: true });
		this.setState({ display: 'none' });
	}

	_onPlay(){
		this.setState({ loading: false });
		this.setState({display: 'block'});
		this.props.onPlay();
	}

	render() {
		let { isOpen, yid } = this.props;

		if (!isOpen || !yid) {
			return (<div></div>);
		}

		// const style = {
		// 	display: this.state.display
		// };

		return (
				<div className="youtubeView">
					<Button className="sp-view-close" onClick={() => this._close()}>X</Button>
					<div className="boxYoutubeView">

						<FadeLoader color={"#666"} loading={this.state.loading} />

						<div className="view-ytb">
							<YouTube
								videoId={yid}
								opts={this.opts}
								onReady={e => this._onReady(e)}
								onPlay={e => this._onPlay()}
								onEnd={e => this._close()}
							/>
						</div>
					</div>
				</div>
		);
	}
}

export default YoutubeView;


// WEBPACK FOOTER //
// ./src/components/YoutubeView.js